'use es6';

import Deal from 'customer-data-objects/deal/DealRecord';
import PropTypes from 'prop-types';
const DealType = PropTypes.instanceOf(Deal);
export default DealType;